import { emptyLayout } from "../../emptyLayout/model"
export class loginLayout extends emptyLayout {
  constructor(opt) {
    super(opt)
  }
}
